import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { LevelService } from '../../providers/level/level.service';
import { SubjectService } from 'src/app/providers/subject/subject.service';
import { ClassSetService } from 'src/app/providers/class-set/class-set.service';
import { ExamtypeService } from 'src/app/providers/examtype/examtype.service';
import { QuestiondifficultyService } from 'src/app/providers/questiondifficulty/questiondifficulty.service';
import { SupervisorService } from 'src/app/providers/supervisor/supervisor.service';
import { StudentService } from 'src/app/providers/student/student.service';
import { ClassService } from 'src/app/providers/class/class.service';
import { ExamService } from 'src/app/providers/exam/exam.service';
import { QuestionService } from 'src/app/providers/question/question.service';
import { DifficultymodifiersService } from '../../providers/difficultymodifiers/difficultymodifiers.service';

export interface LevelData {
  id: number;
  component: string;
}

@Component({
  selector: 'app-delete-confirm-dialog',
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrls: ['./delete-confirm-dialog.component.scss']
})
export class DeleteConfirmDialogComponent implements OnInit {

  id: number;
  component: string;
  local_data: any;

  title: string;
  message: string;

  constructor(public dialogRef: MatDialogRef<DeleteConfirmDialogComponent>,
    private supervisorService: SupervisorService,
    private studentService: StudentService,
    private levelService: LevelService,
    private subjectService: SubjectService,
    private classsetService: ClassSetService,
    private classService: ClassService,
    private examtypeService: ExamtypeService,
    private examService: ExamService,
    private questdiffService: QuestiondifficultyService,
    private questionService: QuestionService,
    public modifierService: DifficultymodifiersService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

    this.local_data = { ...data };
    this.id = this.local_data.id;
    this.component = this.local_data.component;
    console.log('this is the component', this.component);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  onConfirm() {
    switch (this.component) {
      case 'supervisor': {
        console.log("one");
        this.supervisorService.deleteSupervisor(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'student': {
        console.log("one");
        this.studentService.deleteStudent(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'level': {
        console.log("one");
        this.levelService.deleteLevel(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'subject': {
        console.log("two");
        this.subjectService.deleteSubject(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'classset': {
        console.log("three");
        this.classsetService.deleteClassSet(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'examtype': {
        console.log("four");
        this.examtypeService.deleteExamType(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'questiondifficulty': {
        console.log("five");
        this.questdiffService.deleteQuestionDifficulty(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'class': {
        console.log("six");
        this.classService.deleteClass(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'exam': {
        console.log("seven");
        this.examService.deleteExam(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'question': {
        console.log("seven");
        this.questionService.deleteQuestion(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }

      case 'modifiers': {
        console.log("nine");
        this.modifierService.deleteModifier(this.id)
          .pipe(map(
            data => { console.log(data); return data }
          )).subscribe(
            data => {
              return data;
            });
        this.dialogRef.close(true);
        break;
      }


      default: {
        console.log("a+b is 5.");
        break;
      }
    }

  }

  ngOnInit(): void {
  }

}
